module.exports = __webpack_public_path__ + "asset/image-pro-discount-25-c0417cea38142308.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/component/plans/component/plan/image/pro-discount-25.png
// module id = LyR9
// module chunks = 3